import { render, staticRenderFns } from "./Colposcopy.vue?vue&type=template&id=731e64b9&scoped=true"
import script from "./Colposcopy.vue?vue&type=script&lang=js"
export * from "./Colposcopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731e64b9",
  null
  
)

export default component.exports